import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { BatchUpload } from '../../../../components/cards/BatchUpload';
import {
  batchUploadErrorStep,
  batchUploadStep,
} from '../../../../components/cards/BatchUpload.flow';
import { useBatchUpload } from '../../../../components/cards/use-batch-upload';
import { Stepper } from '../../../../components/common/Stepper';
import { tList } from '../../../../utils/t-list';

export const Route = createFileRoute('/_auth/photos/bulk/')({
  component: PhotosUploadPage,
});

function PhotosUploadPage() {
  const { t } = useTranslation();
  const flow = useBatchUpload();

  const steps = tList(t, 'photosUploadPage.steps');

  return (
    <div>
      <Stepper
        steps={steps}
        current={batchUploadStep(flow.flowState)}
        errorStep={batchUploadErrorStep(flow.flowState)}
      />
      <section className="epi-card tone-green">
        <div className="epi-card-head">
          <span className="num">U</span>
          <span className="title">
            {t('photosUploadPage.title', 'Import par lot')}
          </span>
          <span className="meta">
            {t('photosUploadPage.meta', 'ZIP · JPEG/PNG · UPN')}
          </span>
        </div>
        <BatchUpload flow={flow} />
        <Link to="/photos/kiosk" className="btn-link mt-4">
          {t('photoKiosk.link')} →
        </Link>
      </section>
    </div>
  );
}
